var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mixes && _vm.mixes.length)?_c('BaseSection',{attrs:{"padded":""}},[_c('MixGridBlock',{attrs:{"mixes":_vm.mixes}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }